import { ApiError, apiErrorReason } from '@/lib/api';

// Textos de la clasificación por norma desde la ficha (QA F1 #13). Cada rechazo del
// API se traduce a qué pasó y qué hacer; nunca el error crudo (UX-COPY-01).

export function clauseLabel(n: { normCode: string; clause: string }): string {
  return `${n.normCode} ${n.clause}`;
}

const REJECTIONS: Record<string, string> = {
  norm_link_exists: 'El documento ya tiene esa cláusula.',
  inactive_norm: 'Esa cláusula fue desactivada en el catálogo. Elige otra.',
  cross_company_norm: 'Esa cláusula ya no está disponible. Recarga la ficha y elige otra.',
  annulled_document: 'El documento está anulado y ya no admite cambios.',
};

export function classificationError(err: unknown): string {
  const reason = apiErrorReason(err);
  if (reason !== undefined && REJECTIONS[reason] !== undefined) {
    return REJECTIONS[reason];
  }
  if (err instanceof ApiError && err.status === 404) {
    return 'El documento ya no está disponible en esta empresa. Vuelve a la Lista Maestra.';
  }
  if (err instanceof ApiError && err.status === 403) {
    return 'No tienes permiso para clasificar documentos. Pide acceso al Administrador de Calidad.';
  }
  return 'No se pudo guardar. Intenta de nuevo.';
}
